import React from 'react';
import { FDAlert } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const InfoMessage = ({ value }) => {
  if (!value) return null;

  return (<FDAlert title={'Just so you know'} description={value} />);
};
InfoMessage.propTypes = {
  value: PropTypes.string.isRequired,
};
